var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRastreio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 157.66 184.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0098ca;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#0083ca;}.cls-6{fill:#0075ca;}.cls-7{fill:#005eca;}.cls-8{fill:#ffc615;}.cls-9{fill:#ffad15;}.cls-10{fill:#ffa515;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 47.67,
    y1: 139.13,
    x2: 79.06,
    y2: 215.84,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 259.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 78.94,
    y1: 170.43,
    x2: 115.86,
    y2: 170.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.99,
    y1: 184.27,
    x2: 226.74,
    y2: 286.23,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.86,135.69l51.62,46.72a9.09,9.09,0,0,0,12.58-.36l45.72-46.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.94 78.91 78.94 121.54 42.02 100.22 42.02 57.59 78.94 78.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.86 57.59 115.86 100.22 78.94 121.54 78.94 78.91 115.86 57.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42.02 57.59 78.94 78.91 115.86 57.59 78.94 36.28 42.02 57.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42,100.28,78.88,121.6s15.45,28.1,48.74,19.32c0,0-25.43,23-64.39,15.32,0,0-20.89-16.93-21.27-34.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42,121.6V57.67a.49.49,0,0,1-.1.22l.1-.24L22.37,78C2.26,97.55,13.1,122.4,13.1,122.4c17.07,28.53,50.16,33.84,50.16,33.84C41.15,137.52,42,121.6,42,121.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42,57.65,22.37,78S2.84,94.5,13.1,122.45C13.1,122.45-15,85,11,38.89c0,0,9.86-11.49,25.67-10.11l42.17,7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.88,36.34,36.71,28.73S23.26,26.61,11,38.84c0,0,30.53-55.8,95.67-33.63,0,0,9.09,8.59,9.09,25.4v27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M155.45,60.2c-8.21-41-48.74-55-48.74-55C95.32.34,81.71.12,81.71.12,93.26,4,105.35,21.92,111.57,32.27c.13.25,3.94,7.47,4.23,12.84v1.37a6.32,6.32,0,0,0,0,.87v52.93l29.46-20.77C156.86,70.62,155.45,60.2,155.45,60.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M78.88,121.6s14.53,28.1,48.74,19.32c0,0,39.66-28.78,27.83-80.72,0,0,1.41,10.42-10.22,19.31L115.8,98.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRastreio);
export default __webpack_public_path__ + "static/media/logo-rastreio.a4301027207781690fef351cb5653f21.svg";
export { ForwardRef as ReactComponent };